<template>
	<div id="users">
		<!-- navbar on top of page -->

		<nav class="navbar navbar-expand-lg navbar-dark topbar">
			<a class="navbar-brand" href="home">
				<img
					src="../assets/img/iLogDPI.png"
					style="float:left;width:80px;height:40px;"
				/>
			</a>

			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="collapse navbar-collapse" id="navbarSupportedContent">
				<ul class="navbar-nav mr-auto">
					<li class="nav-item">
						<a class="nav-link" href="Dashboard">Dashboard</a>
					</li>

					<li class="nav-item active">
						<a class="nav-link" href="users">
							Users
							<span class="sr-only">(current)</span>
						</a>
					</li>

					<li class="nav-item">
						<a class="nav-link" href="assets">Assets</a>
					</li>
				</ul>

				<form class="form-inline my-2 my-lg-0">
					<input
						class="form-control mr-sm-2"
						type="search"
						placeholder="Search..."
						aria-label="Search"
						v-model="search"
					/>
				</form>
			</div>
			<button
				class="btn btn-outline-success"
				style="margin:5px;"
				data-toggle="modal"
				data-target="#addNewUserBox"
				@click="
					;(checkform = false),
						cancelUser,
						(customerName = null),
						(username = null)
				"
			>
				Add User
			</button>
			<button class="btn btn-outline-danger" @click="logout">Logout</button>
		</nav>
		<img
			class="icon-header"
			src="../assets/img/User.png"
			width="50px"
			height="50px"
		/>

		<!-- role == user -->
		<div class="container" v-if="role == 'user'">
			<br />
			<table class="table table-striped table-dark" id="cssTable">
				<thead>
					<tr>
						<th scope="col">USERNAME</th>
						<th scope="col">Expiration Date</th>
						<th scope="col">Location</th>
						<th scope="col" colspan="2" width="20%" class="text-center">
							ACTIONS
						</th>
					</tr>
				</thead>
				<tbody
					v-for="users in filteredUser"
					v-bind:key="users.id"
					v-bind:href="users.username"
				>
					<tr v-if="customer_name == users.customerName">
						<td>{{ users.username }}</td>
						<td>{{ users.expirationDate }}</td>
						<td>{{ users.location }}</td>
						<td>
							<!-- Button trigger modal -->
							<button
								type="button"
								class="btn btn-edit"
								data-toggle="modal"
								data-target="#EditUserBox"
								@click.prevent="editUser(users), (checkEditform = true)"
							>
								<img
									src="../assets/img/editUserIcon.png"
									width="25px"
									height="25px"
								/>
							</button>

							<!-- Modal -->

							<div
								class="modal fade"
								id="EditUserBox"
								tabindex="-1"
								role="dialog"
								aria-labelledby="EditUserBoxTitle"
								aria-hidden="true"
							>
								<div class="modal-dialog" role="document" v-if="checkEditform">
									<div class="modal-content">
										<div class="modal-header">
											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="!editPassword && !editExpiration && !editUsername && !editLocation"
											>
												edit user
											</h5>
											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="!editPassword && !editExpiration && editUsername && !editLocation"
											>
												edit username
											</h5>
											<br />
											<h5 class="err_text" v-if="usersfailed">
												You already have this username in your organization.
												Please use another username.
											</h5>

											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="editPassword"
											>
												edit password
											</h5>
											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="editExpiration"
											>
												edit expiration period
											</h5>
											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="editLocation"
											>
												edit location
											</h5>
											<button
												type="button"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
												@click="
													;(editPassword = false), (editExpiration = false), (editLocation = false) , (editUsername = false)
												"
											>
												<span aria-hidden="true">&times;</span>
											</button>
										</div>

										<div class="modal-body">
											<div
												class="form-group"
												v-if="!editPassword && !editExpiration && editUsername && !editLocation"
											>
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>

														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															:class="{
																'is-invalid': submitted && $v.username.$error,
															}"
														/>

														<div
															v-if="submitted && $v.username.$error"
															class="invalid-feedback"
														>
															<span v-if="!$v.username.required"
																>Username is required</span
															>

															<span v-if="!$v.username.maxLength"
																>Your username cannot be longer than 20
																characters</span
															>
														</div>
													</div>
												</div>
											</div>

											<div v-if="editPassword">
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>
														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															readonly
														/>
													</div>
												</div>

												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Password</span>
														</div>

														<input
															type="password"
															v-model="password"
															name="password"
															class="form-control"
															:class="{
																'is-invalid': submitted && $v.password.$error,
															}"
														/>

														<div
															v-if="submitted && $v.password.$error"
															class="invalid-feedback"
														>
															<span v-if="!$v.password.required"
																>Password is required</span
															>

															<span v-if="!$v.password.minLength"
																>Password must be at least 6 characters</span
															>
														</div>
													</div>
												</div>
											</div>
											<div v-if="editLocation">
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>
														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															readonly
														/>
													</div>
												</div>

												<div class="form-group">
							<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Location</span>
									</div>
									<input
										type="location"
										v-model="location"
										id="location"
										name="location"
										class="form-control"
									/>
								</div>
												</div>
											</div>
											<div
												v-if="!editPassword && !editExpiration && !editUsername && !editLocation"
											>
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>
														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															readonly
														/>
													</div>
												</div>
											</div>

											<div
												class="form-group"
												v-if="editExpiration && !editPassword && !editUsername && !editLocation"
											>
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>
														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															readonly
														/>
													</div>
												</div>

												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id
																>Expiration Period</span
															>
														</div>
														<select
															v-model="expiration"
															class="form-control"
															:class="{
																'is-invalid': submitted && $v.expiration.$error,
															}"
														>
															<option
																v-for="option in options"
																v-bind:key="option.value"
																:value="option.value"
															>
																{{ option.text }}
															</option>
														</select>
														<div
															v-if="submitted && $v.expiration.$error"
															class="invalid-feedback"
														>
															<span v-if="!$v.expiration.required"
																>Expiration period is required</span
															>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="modal-footer">
											<button
												v-if="editPassword || editExpiration || editUsername || editLocation"
												type="button"
												class="btn btn-secondary"
												@click="
													;(checkEditform = true),
														(editPassword = false),
														(editExpiration = false),
														(editUsername = false),
														(editLocation = false)
												"
											>
												Back
											</button>
											<!-- <button
												v-if="!editPassword && !editUsername && !editExpiration"
												type="button"
												class="btn btn-secondary"
												@click="cancelUser"
											>
												Close
											</button> -->
											<button
												v-if="!editPassword && !editExpiration && !editUsername && !editLocation"
												type="button"
												class="btn btn-success"
												@click="editExpiration = true"
											>
												Expiration Period
											</button>

											<button
												v-if="!editPassword && !editExpiration && !editUsername && !editLocation"
												type="button"
												class="btn btn-warning"
												@click="editPassword = true"
											>
												Password
											</button>
											<button
												v-if="!editPassword && !editExpiration && !editUsername && !editLocation"
												type="button"
												class="btn btn-primary"
												@click="editUsername = true"
											>
												Username
											</button>
											<button
												v-if="!editPassword && !editExpiration && !editUsername && !editLocation"
												type="button"
												class="btn btn-secondary"
												@click="editLocation = true"
											>
												Location 
											</button>
											<button
												v-if="!editPassword && !editExpiration && editUsername && !editLocation"
												type="button"
												class="btn btn-primary"
												@click="editUserCheck"
											>
												Save changes
											</button>
											<button
												v-if="!editPassword && editExpiration && !editUsername && !editLocation"
												type="button"
												class="btn btn-primary"
												@click="editExpirationCheck"
											>
												Save changes
											</button>

											<button
												v-if="editPassword && !editExpiration && !editLocation && !editUsername"
												type="button"
												class="btn btn-primary"
												@click="updateUserAndPassword"
											>
												Save changes
											</button>

											<button
												v-if="!editPassword && !editExpiration && editLocation && !editUsername"
												type="button"
												class="btn btn-primary"
												@click="updateLocation"
											>
												Save changes
											</button>

										</div>
									</div>
								</div>
								<div
									class="modal-dialog text-box"
									role="document"
									v-else-if="!checkEditform"
								>
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title" id="SuccessBoxTitle"></h5>

											<button
												type="button"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
											>
												<span aria-hidden="true">&times;</span>
											</button>
										</div>

										<div class="modal-body text-box">
											<h5>
												user has been change successfully.
											</h5>
										</div>

										<div class="modal-footer">
											<button
												type="button"
												class="btn btn-primary"
												@click=";(checkEditform = true),
														(editPassword = false),
														(editExpiration = false),
														(editUsername = false),
														(editLocation = false)"
											>
												Ok
											</button>
										</div>
									</div>
								</div>
							</div>
						</td>

						<td>
							<button
								type="button"
								class="btn btn-del"
								data-toggle="modal"
								data-target="#DeleteUserBox"
								@click="delUser(users)"
							>
								<img
									src="../assets/img/delUserIcon.png"
									width="25px"
									height="25px"
								/>
							</button>

							<!-- Modal -->

							<div
								class="modal fade"
								id="DeleteUserBox"
								tabindex="-1"
								role="dialog"
								aria-labelledby="DeleteUserBoxTitle"
								aria-hidden="true"
							>
								<div class="modal-dialog" role="document">
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title text-box" id="DeleteUserBoxTitle">
												Confirm Delete
											</h5>
											<button
												type="button"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
											>
												<span aria-hidden="true">&times;</span>
											</button>
										</div>

										<div class="modal-body text-box">
											Confirm Delete Account: {{ username }} ?
										</div>

										<div class="modal-footer">
											<button
												type="button"
												class="btn btn-secondary"
												data-dismiss="modal"
												@click="cancelUser"
											>
												No
											</button>
											<button
												type="button"
												class="btn btn-primary"
												@click.prevent="deleteUser(users)"
												data-dismiss="modal"
											>
												Yes
											</button>
										</div>
									</div>
								</div>
							</div>
						</td>
						<!-- </div> -->
					</tr>
				</tbody>
			</table>

			<!-- Modal -->
			<div
				class="modal fade"
				id="addNewUserBox"
				tabindex="-1"
				role="dialog"
				aria-labelledby="addNewUserBoxTitle"
				aria-hidden="true"
			>
				<div class="modal-dialog" role="document" v-if="!checkform">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="addNewUserBoxTitle">
								Create a new user account
							</h5>

							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="form-group">
								<div class="form-group">
									<h5>{{ this.customer_name }}</h5>
									<br />
									<h5 v-if="usersfailed" class="err_text">
										You already have this hostname in your organization. Please
										use another hostname.
									</h5>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Username*</span>
									</div>
									<input
										type="text"
										v-model="username"
										name="username"
										class="form-control"
										:class="{ 'is-invalid': submitted && $v.username.$error }"
									/>
									<div
										v-if="submitted && $v.username.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.username.required"
											>Username is required</span
										>

										<span v-if="!$v.username.maxLength"
											>Your username cannot be longer than 20 characters</span
										>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Password*</span>
									</div>
									<input
										type="password"
										v-model="password"
										name="password"
										class="form-control"
										:class="{ 'is-invalid': submitted && $v.password.$error }"
									/>
									<div
										v-if="submitted && $v.password.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.password.required"
											>Password is required</span
										>
										<span v-if="!$v.password.minLength"
											>Password must be at least 6 characters</span
										>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Confirm Password*</span>
									</div>
									<input
										type="password"
										v-model="confirmPassword"
										id="confirmPassword"
										name="confirmPassword"
										class="form-control"
										:class="{
											'is-invalid': submitted && $v.confirmPassword.$error,
										}"
									/>
									<div
										v-if="submitted && $v.confirmPassword.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.confirmPassword.required"
											>Confirm Password is required</span
										>
										<span v-else-if="!$v.confirmPassword.sameAsPassword"
											>Passwords must match</span
										>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Expiration Period*</span>
									</div>
									<select
										v-model="expiration"
										class="form-control"
										:class="{ 'is-invalid': submitted && $v.expiration.$error }"
									>
										<option
											v-for="option in options"
											v-bind:key="option.value"
											:value="option.value"
										>
											{{ option.text }}
										</option>
									</select>
									<div
										v-if="submitted && $v.expiration.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.expiration.required"
											>Expiration period is required</span
										>
									</div>
								</div>
							</div>
							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Location</span>
									</div>
									<input
										type="location"
										v-model="location"
										id="location"
										name="location"
										class="form-control"
									/>
								</div>
							</div>
														

						</div>

						<div class="modal-footer">
							<h6 class="text-right">
								* is required field     
							</h6>
							<button
								type="button"
								class="btn btn-secondary"
								data-dismiss="modal"
							>
								Close
							</button>
							<button type="button" class="btn btn-primary" @click="addUser">
								Add User
							</button>
						</div>
					</div>
				</div>
				<div class="modal-dialog" role="document" v-else>
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="SuccessBoxTitle">
								Create a new user account
							</h5>

							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<div class="modal-body">
							<h5>The new user account has been created successfully.</h5>
						</div>

						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-secondary"
								data-dismiss="modal"
								@click="checkform = false"
							>
								Close
							</button>

							<button
								type="button"
								class="btn btn-primary"
								@click="checkform = false"
							>
								Add another user
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- role == management -->

		<div class="container" v-else-if="role == 'management'">
			<br />
			<table class="table table-striped table-dark" id="cssTable">
				<thead>
					<tr>
						<!-- <th width="25%">ID</th> -->
						<th scope="col" width="40%">Customer Name</th>

						<th scope="col" width="20%">USERNAME</th>
						<th scope="col" width="20%">Expiration Date</th>
						<th scope="col" width="20%">Location</th>
						<!-- <th>PASSWORD</th> -->

						<th scope="col" colspan="2" width="20%" class="text-center">
							ACTIONS
						</th>
					</tr>
				</thead>

				<tbody
					v-for="users in filteredUser"
					v-bind:key="users.id"
					v-bind:href="users.username"
				>
					<tr>
						<td>{{ users.customerName }}</td>

						<td>{{ users.username }}</td>
						<td>{{ users.expirationDate }}</td>
						<td>{{ users.location }}</td>
						<!-- <td>{{users.password}}</td> -->

						<td>
							<!-- Button trigger modal -->

							<button
								type="button"
								class="btn btn-edit"
								data-toggle="modal"
								data-target="#EditUserBox"
								@click.prevent="editUser(users), (checkEditform = true)"
							>
								<img
									src="../assets/img/editUserIcon.png"
									width="25px"
									height="25px"
								/>
							</button>

							<!-- Modal -->

							<div
								class="modal fade"
								id="EditUserBox"
								tabindex="-1"
								role="dialog"
								aria-labelledby="EditUserBoxTitle"
								aria-hidden="true"
							>
								<div class="modal-dialog" role="document" v-if="checkEditform">
									<div class="modal-content">
										<div class="modal-header">
											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="!editPassword"
											>
												edit user
											</h5>
											<h5
												class="modal-title text-box"
												id="EditUserBoxTitle"
												v-if="editPassword"
											>
												edit password
											</h5>
											<button
												type="button"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
												@click="editPassword = false"
											>
												<span aria-hidden="true">&times;</span>
											</button>
										</div>

										<div class="modal-body">
											<h5 class="err_text" v-if="usersfailed">
												You already have this username in your organization.
												Please use another username.
											</h5>
											<div class="form-group" v-if="!editPassword">
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>

														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															:class="{
																'is-invalid': submitted && $v.username.$error,
															}"
														/>

														<div
															v-if="submitted && $v.username.$error"
															class="invalid-feedback"
														>
															<span v-if="!$v.username.required"
																>Username is required</span
															>

															<span v-if="!$v.username.maxLength"
																>Your username cannot be longer than 20
																characters</span
															>
														</div>
													</div>
												</div>
											</div>
											<div v-if="editPassword">
												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Username</span>
														</div>
														<input
															type="text"
															v-model="username"
															name="username"
															class="form-control"
															readonly
														/>
													</div>
												</div>

												<div class="form-group">
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text" id>Password</span>
														</div>

														<input
															type="password"
															v-model="password"
															name="password"
															class="form-control"
															:class="{
																'is-invalid': submitted && $v.password.$error,
															}"
														/>

														<div
															v-if="submitted && $v.password.$error"
															class="invalid-feedback"
														>
															<span v-if="!$v.password.required"
																>Password is required</span
															>

															<span v-if="!$v.password.minLength"
																>Password must be at least 6 characters</span
															>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="modal-footer">
											<button
												v-if="!editPassword"
												type="button"
												class="btn btn-secondary"
												data-dismiss="modal"
												@click="cancelUser"
											>
												Close
											</button>

											<button
												v-if="!editPassword"
												type="button"
												class="btn btn-warning"
												@click=";(editPassword = true), (usersfailed = false)"
											>
												Edit Password
											</button>
											<button
												v-if="!editPassword"
												type="button"
												class="btn btn-primary"
												@click="editUserCheck"
											>
												Save changes
											</button>

											<button
												v-if="editPassword"
												type="button"
												class="btn btn-secondary"
												@click="cancelUser, (editPassword = false)"
											>
												Cancel
											</button>

											<button
												v-if="editPassword"
												type="button"
												class="btn btn-primary"
												@click="updateUserAndPassword"
											>
												Save changes
											</button>
										</div>
									</div>
								</div>
								<div
									class="modal-dialog text-box"
									role="document"
									v-else-if="!checkEditform"
								>
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title" id="SuccessBoxTitle"></h5>

											<button
												type="button"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
											>
												<span aria-hidden="true">&times;</span>
											</button>
										</div>

										<div class="modal-body text-box">
											<h5 v-if="!editPassword">
												user has been change successfully.
											</h5>
										</div>

										<div class="modal-footer">
											<button
												type="button"
												class="btn btn-primary"
												@click="
													;(checkEditform = true),
														(editPassword = false),
														(editExpiration = false),
														(editUsername = false),
														(editLocation = false)
												"
											>
												Ok
											</button>
										</div>
									</div>
								</div>
							</div>
						</td>

						<td>
							<button
								type="button"
								class="btn btn-del"
								data-toggle="modal"
								data-target="#DeleteUserBox"
								@click="delUser(users)"
							>
								<img
									src="../assets/img/delUserIcon.png"
									width="25px"
									height="25px"
								/>
							</button>

							<!-- Modal -->

							<div
								class="modal fade"
								id="DeleteUserBox"
								tabindex="-1"
								role="dialog"
								aria-labelledby="DeleteUserBoxTitle"
								aria-hidden="true"
							>
								<div class="modal-dialog" role="document">
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title text-box" id="DeleteUserBoxTitle">
												Confirm Delete
											</h5>
											<button
												type="button"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
											>
												<span aria-hidden="true">&times;</span>
											</button>
										</div>

										<div class="modal-body text-box">
											Confirm Delete Account: {{ username }} ?
										</div>

										<div class="modal-footer">
											<button
												type="button"
												class="btn btn-secondary"
												data-dismiss="modal"
												@click="cancelUser"
											>
												No
											</button>
											<button
												type="button"
												class="btn btn-primary"
												@click.prevent="deleteUser(users)"
												data-dismiss="modal"
											>
												Yes
											</button>
										</div>
									</div>
								</div>
							</div>
						</td>

						<!-- </div> -->
					</tr>
				</tbody>
			</table>

			<!-- Modal Add User Box-->

			<div
				class="modal fade"
				id="addNewUserBox"
				tabindex="-1"
				role="dialog"
				aria-labelledby="addNewUserBoxTitle"
				aria-hidden="true"
			>
				<div class="modal-dialog" role="document" v-if="!checkform">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="addNewUserBoxTitle">
								Create a new user account
							</h5>
							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<div class="modal-body">
							<div class="form-group">
								<div class="form-group">
									<h5>DPI Admin</h5>
									<br />
									<h5 class="err_text" v-if="usersfailed">
										You already have this username in your organization. Please
										use another username.
									</h5>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Customer Name</span>
									</div>

									<input
										type="text"
										v-model="customerName"
										id="customerName"
										name="customerName"
										class="form-control"
										:class="{
											'is-invalid': submitted && $v.customerName.$error,
										}"
									/>

									<div
										v-if="submitted && $v.customerName.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.customerName.required"
											>Customer Name is required</span
										>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Username</span>
									</div>

									<input
										type="text"
										v-model="username"
										name="username"
										class="form-control"
										:class="{ 'is-invalid': submitted && $v.username.$error }"
									/>

									<div
										v-if="submitted && $v.username.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.username.required"
											>Username is required</span
										>

										<span v-if="!$v.username.maxLength"
											>Your username cannot be longer than 20 characters</span
										>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Password</span>
									</div>

									<input
										type="password"
										v-model="password"
										name="password"
										class="form-control"
										:class="{ 'is-invalid': submitted && $v.password.$error }"
									/>

									<div
										v-if="submitted && $v.password.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.password.required"
											>Password is required</span
										>

										<span v-if="!$v.password.minLength"
											>Password must be at least 6 characters</span
										>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id>Confirm Password</span>
									</div>

									<input
										type="password"
										v-model="confirmPassword"
										id="confirmPassword"
										name="confirmPassword"
										class="form-control"
										:class="{
											'is-invalid': submitted && $v.confirmPassword.$error,
										}"
									/>

									<div
										v-if="submitted && $v.confirmPassword.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.confirmPassword.required"
											>Confirm Password is required</span
										>

										<span v-else-if="!$v.confirmPassword.sameAsPassword"
											>Passwords must match</span
										>
									</div>
								</div>
							</div>
						</div>

						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-secondary"
								data-dismiss="modal"
								@click="cancelUser"
							>
								Close
							</button>
							<button type="button" class="btn btn-warning" @click="clearData">
								Clear
							</button>
							<button type="button" class="btn btn-primary" @click="addUser">
								Add User
							</button>
						</div>
					</div>
				</div>

				<div class="modal-dialog" role="document" v-else>
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="SuccessBoxTitle">
								Create a new user account
							</h5>

							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<div class="modal-body">
							<h5>The new user account has been created successfully.</h5>
						</div>

						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-secondary"
								data-dismiss="modal"
								@click="cancelUser(), (customerName = null)"
							>
								Close
							</button>

							<button
								type="button"
								class="btn btn-primary"
								@click="checkform = false"
							>
								Add another user
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="hr-foot-2"></div>
	</div>
</template>

<script>
import Vue from 'vue'
import jwtDecode from 'jwt-decode'
import Vuelidate from 'vuelidate'

import firebase from 'firebase/app'
import '@firebase/auth'
import '@firebase/database'
import '@firebase/analytics'

import {
	required,
	minLength,
	maxLength,
	sameAs,
} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

Vue.config.productionTip = false

const usersRef = firebase
	.database()
	.ref('Users')
	.orderByChild('customerName')
const usersDB = firebase.database().ref('Users')

export default {
	name: 'Users',
	data() {
		return {
			username: '',
			password: '',
			confirmPassword: '',
			customerName: '',
			expirationDate: '',
			location: '',
			users: [],
			search: '',
			currentDate: '',
			currentTime: '',
			editName: null,
			editUsername: false,
			editPassword: false,
			editExpiration: false,
			editLocation: false,
			submitted: false,
			checkform: false,
			checkEditform: false,
			notUnique: false,
			usersfailed: false,
			fields: [
				{
					key: 'username',
					sortable: true,
				},
			],
			expiration: 'Never',
			options: [
				{ text: 'Never', value: '0' },
				{ text: '1 Day', value: 'day' },
				{ text: '1 Week', value: 'week' },
				{ text: '1 Month', value: '1M' },
				{ text: '3 Months', value: '3M' },
				{ text: '6 Months', value: '6M' },
				{ text: '1 Year', value: '1Y' },
			],
		}
	},
	validations: {
		username: { required, maxLength: maxLength(20) },
		password: { required, minLength: minLength(6) },
		confirmPassword: { required, sameAsPassword: sameAs('password') },
		customerName: { required },
		expiration: { required },
	},
	methods: {
		unique() {
			for (let x = 0; x < this.users.length; x++) {
				let customer = ''
				if (this.role == 'user') {
					customer = this.customer_name
				} else if (this.role == 'management') {
					customer = this.customerName
				}
				if (this.users[x].username == this.username) {
					//console.log(this.users[x])
					if (this.users[x].customerName == customer) {
						// alert(
						//   "You already have this username (" +
						//     this.username +
						//     ") in your organization. \n\n\nPlease use another username."
						// );
						this.usersfailed = true
						this.password = ''
						this.confirmPassword = ''
						this.notUnique = true
						return
					}
				}
			}
			this.notUnique = false
		},
		addUser() {
			this.submitted = true

			//stop here if form is invalid

			if (this.role == 'management') {
				this.$v.$touch()
				if (this.$v.$invalid) {
					return
				}
			}

			if (this.role == 'user') {
				this.$v.$touch()
				if (
					this.$v.username.$invalid ||
					this.$v.password.$invalid ||
					this.$v.confirmPassword.$invalid
				) {
					return
				}
			}

			this.unique()
			if (this.notUnique == false) {
				this.storeUser()
			}
		},

		editUserCheck() {
			this.submitted = true

			//stop here if form is invalid

			this.$v.$touch()
			if (this.$v.username.$invalid) {
				return
			}
			this.unique()
			if (this.notUnique == false) {
				this.updateUser()
			}
		},
		createExpirationDate() {
			if (this.expiration == '0') {
				this.expirationDate = 'Never'
			} else {
				if (this.expiration == 'day') {
					this.currentTime = new Date().getTime() + 86400 * 1000
				} else if (this.expiration == 'week') {
					this.currentTime = new Date().getTime() + 604800 * 1000
				} else if (this.expiration == '1M') {
					this.currentTime = new Date().getTime() + 2629743 * 1000
				} else if (this.expiration == '3M') {
					this.currentTime = new Date().getTime() + 7890000 * 1000
				} else if (this.expiration == '6M') {
					this.currentTime = new Date().getTime() + 15780000 * 1000
				} else {
					this.currentTime = new Date().getTime() + 31556926 * 1000
				}
				this.currentDate = new Date(this.currentTime)
				var months = [
					'Jan',
					'Feb',
					'Mar',
					'Apr',
					'May',
					'Jun',
					'Jul',
					'Aug',
					'Sep',
					'Oct',
					'Nov',
					'Dec',
				]
				var date = this.currentDate.getDate()
				var month = months[this.currentDate.getMonth()]
				var year = this.currentDate.getFullYear()

				this.expirationDate = date + ' ' + month + ' ' + year
			}
		},
		editExpirationCheck() {
			this.submitted = true

			//stop here if form is invalid

			this.$v.$touch()
			if (this.$v.username.$invalid) {
				return
			}
			this.createExpirationDate()

			usersDB.child(this.editName.id).update({
				expirationTime: this.expiration,
				expirationDate: this.expirationDate,
				timestamp: firebase.database.ServerValue.TIMESTAMP,
			})
			this.cancelUser()		 
		},
		updateLocation() {
			usersDB.child(this.editName.id).update({
				location: this.location
			})
			this.cancelUser()
			this.checkEditform = false		
		},
		storeUser() {
			var passwordHash = require('password-hash')
			var hashedPassword = passwordHash.generate(this.password)
			this.createExpirationDate()
			if (this.role == 'user') {
				usersDB.push({
					username: this.username,
					password: hashedPassword,
					customerName: this.customer_name,
					expirationTime: this.expiration,
					expirationDate: this.expirationDate,
					timestamp: firebase.database.ServerValue.TIMESTAMP,
					location: this.location
				})
			} else if (this.role == 'management') {
				usersDB.push({
					username: this.username,
					password: hashedPassword,
					customerName: this.customerName,
				})
			}
			this.checkform = true
			this.cancelUser()
		},
		deleteUser() {
			usersDB.child(this.editName.id).remove()
		},
		editUser(users) {
			users.password = ''
			this.editName = users
			this.username = users.username
			this.password = users.password
			this.customerName = users.customerName
		},
		delUser(users) {
			this.editName = users
			this.username = users.username
		},
		cancelUser() {
			// this.editName = null
			// this.username = ''
			this.password = ''
			this.confirmPassword = ''
			this.submitted = false
			this.usersfailed = false
			this.assetsfailed = false
			this.editExpiration = false
			this.editLocation = false
			this.location = ''
		},
		clearData() {
			this.username = ''
			this.password = ''
			this.confirmPassword = ''
			this.customerName = ''
		},
		updateUser() {
			usersDB.child(this.editName.id).update({
				username: this.username,
			})
			this.cancelUser()
			this.checkEditform = false
		},
		updateUserAndPassword() {
			this.submitted = true

			//stop here if form is invalid

			this.$v.$touch()
			if (this.$v.password.$invalid) {
				return
			}
			var passwordHash = require('password-hash')
			var hashedPassword = passwordHash.generate(this.password)
			usersDB.child(this.editName.id).update({
				password: hashedPassword,
			})
			this.cancelUser()
			this.checkEditform = false
		},
		logout() {
			firebase
				.auth()
				.signOut()
				.then(function() {
					// Sign-out successful.
				})
			sessionStorage.removeItem('user-token')
			this.$router.push({
				name: 'login',
			})
		},
	},
	created() {
		this.token = sessionStorage.getItem('user-token')
		this.decoded = jwtDecode(this.token)
		this.role = this.decoded.role
		this.customer_name = this.decoded.customer_name

		usersRef.on('child_added', (snapshot) => {
			this.users.push({ ...snapshot.val(), id: snapshot.key })
		})
		usersRef.on('child_removed', (snapshot) => {
			const deleteUser = this.users.find((users) => users.id == snapshot.key)
			const index = this.users.indexOf(deleteUser)
			this.users.splice(index, 1)
		})
		usersRef.on('child_changed', (snapshot) => {
			const updateUser = this.users.find((users) => users.id == snapshot.key)
			updateUser.username = snapshot.val().username
			updateUser.expirationDate = snapshot.val().expirationDate
			updateUser.location = snapshot.val().location
		})
	},
	computed: {
		filteredUser() {
			return this.users.filter((users) => {
				return users.username.toLowerCase().includes(this.search.toLowerCase())
			})
		},
	},
}
</script>

<style>
body {
	max-height: 3840px;
	max-width: 2160px;
	background-color: #1a1d20;
}

#users {
	color: #1c2833;
	width: 100%;
	height: 100%;
	position: static;
	text-align: center;
	font: 600 16px/18px 'Open Sans', sans-serif;
}

table {
	font-family: arial, sans-serif;
	border-collapse: collapse;
	max-width: 100%;
	max-height: 100%;
}

th {
	text-align: left;
	vertical-align: middle;
	padding: 8px;
}

tr {
	max-height: 100%;
	max-width: 100%;
}
td {
	max-height: 100%;
	max-width: 100%;
	background-color: #292c30;
}

#cssTable td {
	text-align: left;
	vertical-align: middle;
	border-bottom-style: ridge;
}

.icon-header {
	margin-top: 50px;
}

.btn-header-space {
	margin-right: 5px;
}

.btn-add {
	background-color: Transparent;
	background-repeat: no-repeat;
	border: none;
	cursor: pointer;
	overflow: hidden;
	outline: none;
	position: fixed;
	right: 80px;
	bottom: 20px;
}

.btn-edit {
	background-color: #dbd7d7;
	width: 100%;
	height: 100%;
	border: none;
}

.btn-del {
	background-color: #dbd7d7;
	width: 100%;
	height: 100%;
	border: none;
}

/* .hr-foot-2 {
  height: 2px;
  margin: 30px 0 0 0;
  background: rgba(255, 255, 255, 0.2);
} */

*:focus {
	outline: 0;
}

button.btn-edit:hover {
	cursor: pointer;
	background-color: #f89900;
}

button.btn-del:hover {
	cursor: pointer;
	background-color: #d22d2d;
}

.text-box {
	width: 100%;
	text-align: center;
	color: black;
}

.nrdy {
	cursor: not-allowed;
}

.err_text {
	color: red;
}
</style>
